<span *ngIf="displayTitle && rights.length > 0">{{ "profile.provider.microsoft.exchange.grantedRights" | i18next  }} </span>
<span *ngIf="displayTitle && rights.length == 0">{{ "profile.provider.microsoft.exchange.noGrantedRights" | i18next  }} </span>

<span class="rights">{{rights}}</span>